import { useState, Fragment, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useSignIn, useSignOut } from "react-auth-kit";
import { sendApiRequest } from "../../services/Base/base-service";

import UserContext from "../../store/user-context";
import {
  Alert,
  Button,
  FormGroup,
  Icon,
  Modal,
  ModalBody,
  ModalHeader,
  Select,
  Spinner,
} from "design-react-kit";

import secureLocalStorage from "react-secure-storage";

const MunicipalityChangeModal = ({ modalOpen, modalCloseHandler }) => {
  const [municipality, setMunicipality] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [defaultOptions, setDefaultOptions] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    if (modalOpen) {
      setError(null);
      setIsLoading(true);
      sendApiRequest(
        "Client/GetAllClients",
        "GET",
        true,
        null,
        signIn,
        signOut,
        navigate,
        null,
        userContext
      ).then((response) => {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          const options = [];
          response.data.map((item) =>
            options.push({
              value: item.fiscalCode,
              label: item.name,
              twoFactorEnabled: item.twoFactorEnabled,
            })
          );
          setDefaultOptions(options);
          setIsLoading(false);
          if (
            userContext.selectedClientName !== null &&
            userContext.selectedClientTwoFactorEnabled !== null &&
            userContext.selectedClientFiscalCode !== null
          ) {
            setMunicipality({
              value: userContext.selectedClientFiscalCode,
              label: userContext.selectedClientName,
              twoFactorEnabled: userContext.selectedClientTwoFactorEnabled,
            });
          }
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);

  const saveClientHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    sendApiRequest(
      "Client/SaveLastClient",
      "POST",
      true,
      { fiscalCode: municipality.value },
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          if (secureLocalStorage.getItem("selectedClient") !== null) {
            secureLocalStorage.removeItem("selectedClient");
          }
          secureLocalStorage.setItem("selectedClient", {
            fiscalCode: municipality.value,
            name: municipality.label,
            twoFactorEnabled: municipality.twoFactorEnabled,
          });
          userContext.setSelectedClientFiscalCode(municipality.value);
          userContext.setSelectedClientName(municipality.label);
          userContext.setSelectedClientTwoFactorEnabled(
            municipality.twoFactorEnabled
          );
          setIsLoading(false);
          modalCloseHandler();
          navigate("/");
        }
      }
    });
  };

  const handleChange = (selectedOption) => setMunicipality(selectedOption);

  return (
    <Fragment>
      <Modal
        isOpen={modalOpen}
        labelledBy="municipalityChange"
        toggle={
          userContext.selectedClientFiscalCode !== null &&
          userContext.selectedClientName !== null
            ? modalCloseHandler
            : null
        }
      >
        <ModalHeader
          id="municipalityChange"
          toggle={
            userContext.selectedClientFiscalCode !== null &&
            userContext.selectedClientName !== null
              ? modalCloseHandler
              : null
          }
        >
          Scegli l'ente di riferimento
        </ModalHeader>
        <ModalBody>
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mb-5">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          {isLoading && (
            <p style={{ height: "50px" }}>
              <Spinner double active />
            </p>
          )}
          <FormGroup className="col-sm-12 m-0 position-relative mb-5">
            <div className="bootstrap-select-wrapper">
              <label htmlFor="selectExampleSearch">Enti disponibili</label>
              <Select
                id="selectExampleSearch"
                isSearchable={true}
                onChange={handleChange}
                options={defaultOptions}
                value={municipality}
                placeholder="-Seleziona l'ente-"
                aria-label="-Seleziona l'ente-"
              />
            </div>
          </FormGroup>

          {municipality !== null &&
            municipality.value !== userContext.selectedClientFiscalCode &&
            municipality.label !== userContext.selectedClientName && (
              <div className="col-sm-12 mb-2 d-flex align-items-center justify-content-end">
                <Button
                  style={{
                    backgroundColor: "#5EB423",
                    color: "#fff",
                    padding: "7px 15px",
                  }}
                  id="sent-mail"
                  onClick={(e) => saveClientHandler(e)}
                >
                  <Icon icon="it-check" fill="#ffffff" /> Conferma
                </Button>
              </div>
            )}
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default MunicipalityChangeModal;
